<template lang="html">
  <div class="content-wrapper">
    <div class="row">
      <div class="col-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body pt-3" style="padding: 0!important">
            <div class="TVChartContainer" :id="container" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from './api'
export default {
  props: {
    symbol: {
        default: 'BTCUSDT',
        type: String,
      },
      interval: {
        default: '4h',
        type: String,
      },
      container: {
        default: 'tv_chart_container',
        type: String,
      },
      datafeedUrl: {
        default: 'https://demo_feed.tradingview.com',
        type: String,
      },
      libraryPath: {
        default: '/static/charting_library/charting_library/',
        type: String,
      },
      chartsStorageUrl: {
        default: 'https://api.tradingapp.pro',
        type: String,
      },
      chartsStorageApiVersion: {
        default: 'save_chart',
        type: String,
      },
      clientId: {
        default: 'tradingview.com',
        type: String,
      },
      userId: {
        default: 'tradingapp',
        type: String,
      },
      fullscreen: {
        default: false,
        type: Boolean,
      },
      autosize: {
        default: true,
        type: Boolean,
      },
      studiesOverrides: {
        type: Object
      }
  },
  tvWidget: null,

  mounted () {
    this.axios.get('/user/overview', {withCredentials: true})
      .then((userInfo) => {
        var id = userInfo.data.id
        if(id > 0){
          const widgetOptions = {
            symbol: this.symbol,
            // BEWARE: no trailing slash is expected in feed URL
            datafeed: api,//new window.Datafeeds.UDFCompatibleDatafeed(this.datafeedUrl),
            interval: this.interval,
            container: this.container,
            library_path: this.libraryPath,
            theme: 'dark',
            locale: 'en',
            disabled_features: ['use_localstorage_for_settings'],
            // enabled_features: ['study_templates'],
            charts_storage_url: this.chartsStorageUrl,
            hide_top_toolbar: false,
            charts_storage_api_version: this.chartsStorageApiVersion,
            client_id: 'tradingview.com',
            user_id: id,
            fullscreen: this.fullscreen,
            autosize: this.autosize
          }

          this.tvWidget = new TradingView.widget(widgetOptions)

          this.tvWidget.onChartReady(() => {
          })
        }
    })

  },
  destroyed() {
    if (this.tvWidget !== null) {
      this.tvWidget.remove()
      this.tvWidget = null
    }
  }
}
</script>

<style lang="css">
.TVChartContainer {
  height: 90vh;
}
</style>



// WEBPACK FOOTER //
// src/components/chart_backtest.vue